export default {
  qInfo: { qType: 'dataMatchups' },
  qHyperCubeDef: {
    qDimensions: [
      {
        qDef: {
          qFieldDefs: ['Team A'],
          qSortCriterias: [
            {
              qSortByAscii: 1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Team B'],
          qSortCriterias: [
            {
              qSortByAscii: 1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Win A'],
          qSortCriterias: [
            {
              qSortByAscii: 1,
            },
          ],
        },
        qNullSuppression: false,
      }, {
        qDef: {
          qFieldDefs: ['Win B'],
          qSortCriterias: [
            {
              qSortByAscii: 1,
            },
          ],
        },
        qNullSuppression: false,
      },
    ],
    qInitialDataFetch: [{
      qWidth: 4,
      qHeight: 2500,
    }],
  },
};
